// extracted by mini-css-extract-plugin
export default {"homeMain":"HomePage_homeMain__SOjtT"};